import { Injectable } from '@angular/core';
import { HttpModelConverter } from '../../../../../../core/converter/httpModel.converter';
import { TreatmentFeedbackModel } from '../treatment-feedback.model';
import { TreatmentFeedbackSummaryConverter } from './treatment-feedback.summary.converter';

@Injectable()
export class TreatmentFeedbackConverter extends HttpModelConverter<TreatmentFeedbackModel> {

    constructor(private treatmentFeedbackSummaryConverter: TreatmentFeedbackSummaryConverter) {
        super();
    }

    protected createInstance(): TreatmentFeedbackModel {
        return new TreatmentFeedbackModel();
    }

    protected enrichObject(result: TreatmentFeedbackModel, src: TreatmentFeedbackModel) {
        result.summary = this.treatmentFeedbackSummaryConverter.convert(src.summary);
    }

}
